<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPhoneHorisontal_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M1.282 13.967c-.317-1.135-.03-2.438.764-3.49 1.529-2.022 4.9-3.213 10.046-3.214 6.29 0 8.934 1.747 10.046 3.213.795 1.05 1.081 2.355.763 3.49a1.71 1.71 0 0 1-2.073 1.204l-3.688-.921a1.718 1.718 0 0 1-1.304-1.67l-.02-1.316a15.693 15.693 0 0 0-3.723-.414 19.04 19.04 0 0 0-3.685.353l-.058 1.386a1.713 1.713 0 0 1-1.303 1.662l-3.689.923a1.717 1.717 0 0 1-2.076-1.206Z"
    />
</svg>
